import { baseApiQuery } from '@/shared/helpers/api';
import { createApi } from '@reduxjs/toolkit/query/react';
export const baseApi = createApi({
    baseQuery: baseApiQuery,
    // tagTypes: ['Articles'],
    endpoints: () => ({}),
    refetchOnFocus: false,
    refetchOnMountOrArgChange: false,
    refetchOnReconnect: true,
});
